import { render } from "./CopyToListAction.vue?vue&type=template&id=7cffa672"
import script from "./CopyToListAction.vue?vue&type=script&lang=ts"
export * from "./CopyToListAction.vue?vue&type=script&lang=ts"
script.render = render

export default script